import { mutate } from "swr";
import { setIsLoading } from "../store";
import { fetchGlobal } from "../../../../../api/hooks";

export async function editSale(franchiseID: any, updatedRows: any, setIsAddSaleSupportClicked: Function,
    setDataIsUpdated: Function, dataIsUpdated: boolean | number) {
    const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/defaultSetting/data`;
    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            franchiseId: franchiseID,
            types: ["saleMode"],
            data: updatedRows,
        }),
    };
    try {
        const data = await fetchGlobal<any>(apiUrl, requestOptions);

        if (data.error) {
            throw Error("error");
        } else {
            setDataIsUpdated(!dataIsUpdated);
            setIsAddSaleSupportClicked(false);
        }
        setIsLoading(false);

        mutate(apiUrl, data);
    } catch (e) {
        setIsLoading(false);
    }
};